import React, { JSX, useId } from 'react'

export const confirmDialogKeyDown = (
  e: { key: string, stopPropagation: () => void },
  onCancel: () => void
): void => {
  e.stopPropagation()
  if (e.key === 'Escape') onCancel()
}

export const ConfirmDialog = ({
  title,
  children,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  testId
}: {
  title: string
  children: React.ReactNode
  confirmLabel: string
  cancelLabel: string
  onConfirm: () => void
  onCancel: () => void
  testId?: string
}): JSX.Element => {
  const titleId = useId()
  return (
    <div
      className='fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4'
      data-testid={testId}
      tabIndex={-1}
      onKeyDown={(e) => confirmDialogKeyDown(e, onCancel)}
    >
      <div
        role='dialog'
        aria-modal='true'
        aria-labelledby={titleId}
        className='max-h-[90vh] w-full max-w-md overflow-y-auto rounded-xl border border-white/10 bg-dm-bg-secondary p-6 shadow-2xl'
      >
        <h2 id={titleId} className='text-lg font-semibold text-dm-text-primary'>
          {title}
        </h2>
        <div className='mt-2 text-sm text-dm-text-secondary'>
          {children}
        </div>
        <div className='mt-5 flex items-center justify-end gap-2'>
          <button
            type='button'
            onClick={onCancel}
            autoFocus
            data-testid={testId != null ? `${testId}-cancel` : undefined}
            className='rounded-md border border-white/10 px-4 py-2 text-sm font-medium text-dm-text-secondary hover:border-white/20 hover:text-dm-text-primary'
          >
            {cancelLabel}
          </button>
          <button
            type='button'
            onClick={onConfirm}
            data-testid={testId != null ? `${testId}-confirm` : undefined}
            className='rounded-md bg-brand px-4 py-2 text-sm font-semibold text-black hover:bg-brand/80'
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
